import classNames from "classnames";
import block from "bem-css-modules";

import s from './Session.module.scss';
import {Lecturer} from "./Lecturer";
import {Modal} from "react-bootstrap";
import {useState} from "react";

const b = block(s);
export const Session = ({session, index, noBorder}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div className={classNames('col-9 row', b('content', {dark: index % 2 === 0, 'no-border': noBorder}))}>
            <div className={classNames('col-12 col-md-6', b('title'))} onClick={handleShow}>{session.title}</div>
            <div className={classNames('col-12 col-md-2', b('location'))}>{session.location}</div>
            <div
                className={'col-12 col-md-4'}>{session.lecturers.map(lecturer => <Lecturer lecturer={lecturer}/>)}</div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{session.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div dangerouslySetInnerHTML={{__html: session.description}}></div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
